export function DefaultLuminaryDisclaimer() {
  return (
    <>
      <p>
        Luminary is a web-based estate and wealth transfer platform designed for
        professional use. All outputs, calculations, projections, reports, and
        insights generated by Luminary are illustrative in nature and are not
        intended as legal, tax, or investment advice. Certain features within
        the platform incorporate artificial intelligence to generate outputs,
        and advisors should independently validate all information and outputs
        generated by Luminary before relying on or presenting them to clients.
        Use of the Luminary platform does not create an attorney-client
        relationship between Luminary and any user.
      </p>

      <p>
        Luminary&apos;s calculations and assumptions are based on user inputs
        and the platform&apos;s current understanding and interpretation of
        applicable tax laws, regulations, and rates, which are subject to change
        as laws and other factors evolve. The methodologies and assumptions used
        within the platform may not capture a client&apos;s complete financial
        picture or personal context. The most recent assumptions and calculation
        methodologies are available within the application.
      </p>

      <p>
        Luminary&apos;s Insights and Observations &amp; Opportunities features
        use automated analysis of client data and user-uploaded documents to
        identify potential estate planning considerations and strategies. These
        outputs are illustrative and may not reflect a client&apos;s full
        circumstances.
      </p>

      <p>
        Estate360 reports provide an automated overview of user-uploaded estate
        planning documents for discussion purposes only. Estate360 outputs may
        not reflect a client&apos;s full circumstances and do not constitute
        legal, tax, or investment advice.
      </p>

      <p>
        Wealth transfer strategy proposals modeled within Luminary may include
        Grantor Retained Annuity Trusts (GRATs), Charitable Remainder Trusts
        (CRTs), Charitable Lead Trusts (CLTs), installment sales, intra-family
        loans, Irrevocable Life Insurance Trusts (ILITs), gifts, and other
        wealth transfer arrangements. The material presented is designed to
        illustrate potential ideas and strategies for discussion purposes only.
        The availability, suitability, and effectiveness of any strategy depend
        on individual facts and circumstances. All analyses and projections
        performed in Luminary are illustrative and are not guarantees or
        predictions of future results or performance.
      </p>

      <p>
        The estate waterfall, tax calculations, and value creation reporting are
        likewise illustrative in nature and are not intended as legal, tax, or
        investment advice.
      </p>

      <p>
        Luminary does not provide investment advice, make recommendations, or
        promote any advisory services or specific investments. Asset growth
        defaults and assumptions within the platform are for illustrative estate
        and wealth-transfer planning purposes only and do not represent actual
        or expected investment results, the performance of any investment
        strategy, or forecasts of future returns. Certain outputs may reflect
        hypothetical or modeled performance based on user-defined inputs.
      </p>

      <p>
        Advisors are responsible for ensuring that any assumptions, outputs, and
        materials shared with clients comply with applicable laws and
        regulations, including the SEC&apos;s Marketing Rule (Rule 206(4)-1).
      </p>
    </>
  );
}
